import * as _ from 'lodash-es';

/**
 * Create a map (object) using the keys and values provided, 
 * transforming each item using the generator function
 * @param map object with keys and input values
 * @param generator function to transform each input value
 * @returns object with keys from input and transformed values
 */
export function createPromiseMap(map = {}, generator) {
    const ret = _.zipObject(
        _.keys(map),
        _.map(_.values(map), generator)
    );
    return ret;
};

/**
 * Execute the promises from the provided map
 * @param map object JS map/object
 * @returns object A new object with keys from the input map, and values from the resolved promises.
 */
export function doPromiseAll(map = {}) {
    const keys: any = _.keys(map);
    return Promise.all(
        _.values(map)
    ).then(
        (arr: any) => _.zipObject(keys, arr),
        (err) => err
    );
};